(ns motorsaif.web.pages.settings.business
  (:require
   [clojure.string :as str]
   [goog.string :refer [format]]
   [motorsaif.data-utils :as data-utils]
   [motorsaif.frontend-routes :as routes]
   [motorsaif.i18n :as i18n :refer [tr]]
   [motorsaif.url :as url]
   [motorsaif.utils :as utils]
   [motorsaif.validation :as validation]
   [motorsaif.web.components :as c]
   [motorsaif.web.components.step-form :as sf]
   [motorsaif.web.components.step-inputs :as si]
   [motorsaif.web.lib.form :as form]
   [motorsaif.web.photos :as photos]
   [motorsaif.web.storage :as storage]
   [re-frame.core :as rf :refer [subscribe]]
   [reagent.ratom :as ra]))

(defn photos [{:keys [form]}]
  (let [trs (i18n/tr-scope [:step-inputs :photos])
        {:keys [uploader uploaded-media get-val retract-fn]} form]
    [:div.step-input-variant-1.elevated
     [:div.form-section
      [:h3 (trs :photos "Photos")]
      [:p (trs :desc "Let users see what your business looks like")]
      [:p (trs :optional "*Optional")]
      [:div#issues
       (let [media-path [:business :business/media]]
         [:div
          [:div.full-upload-wrapper
           [uploaded-media
            {:after-remove
             (fn [{id :db/id :as itm}]
               (let [parent-id (get-val [:business :db/id])]
                 (retract-fn {:parent-id parent-id
                              :key :business/media
                              :item-id id})))}
            media-path]
           [uploader media-path]]])]]]))

(defn business-information [{:keys [form]}]
  (let [trs (i18n/tr-scope [:business :basic-information])
        {:keys [input get-val set-val *realtime-validation]} form]
    [:div.step-input-variant-1.elevated
     [:h1 (tr :title "Basic Information")]
     [:div
      [input
       {:label (trs [:name :label] "Business Name")}
       [:business :business/name]]
      [input
       {:label (trs [:email :label] "Business Email")}
       [:business :business/email]]]]))

(defn services [args]
  [:div.step-input-variant-1.elevated
   [si/services args]])

(defn location [args]
  [:div.step-input-variant-1.elevated
   [si/location args]])

(defn whatsapp [args]
  [:div.step-input-variant-1.elevated
   [si/whatsapp args]])

(defn review [{:keys [form]}]
  (let [trs (i18n/tr-scope [:business-signup :review])
        {:keys [*data]} form
        {:keys [business user]} @*data]
    [:div#review
     (let [trs (i18n/tr-scope [:business-signup :review :business])
           {:business/keys [name email coords geo-location misc]} business
           {:keys [filters whatsapp]} misc]

       [:section
        [:a.header
         {:href (routes/path-for :settings-business-step {:step :info})}
         [:h2 (trs :title "Basic Information")]]
        [:div.grid.row
         [:div.info-group
          [:div.title (trs :name "Name")] [:div.val name]]
         [:div.info-group
          [:div.title (trs :email "Email")] [:div.val {:class (utils/cond-css (nil? email) "nil")} (or email "Not Entered")]]]])

     (let [trs (i18n/tr-scope [:business-signup :review :business])
           {:business/keys [media]} business]
       [:section
        [:a.header
         {:href (routes/path-for :settings-business-step {:step :media})}
         [:h2 (trs :titl "Media")]]
        [:div.grid.summary
         (if-not (seq media)
           [:span.title (trs :media "Media")]
           [:span])
         (into [:div.media
                {:class (str "items-" (count media))}
                (map-indexed
                 (fn [idx itm]
                   (let [{media-id :db/id
                          path :media/path} itm
                         src (url/uploaded-media {:media itm
                                                  :size :med})]
                     ^{:key media-id}
                     [:div.media-item
                      {:on-click #(photos/photoswipe idx media)}
                      [:img {:src src}]])) (take 5 (sort-by :media/order media)))])]])

     (let [trs (i18n/tr-scope [:business-signup :review :business])
           {:business/keys [name email coords geo-location misc]} business
           {:keys [filters whatsapp]} misc
           whatsapp (or whatsapp "Not Provided")]
       [:section
        [:a.header
         {:href (routes/path-for :settings-business-step {:step :whatsapp})}
         [:h2 (trs :titl "WhatsApp")]]
        [:div.grid.summary
         [:span.title (trs :whatsapp "Whatsapp")] [:span.val whatsapp]]])

     (let [trs (i18n/tr-scope [:business-signup :review :services])
           {:business/keys [name email coords geo-location misc]} business
           {:keys [filters whatsapp]} misc]
       [:section
        [:a.header
         {:href (routes/path-for :settings-business-step {:step :services})}
         [:h2 (trs :title "Services")]]
        [:div.grid
         [:div.feed-filters
          (into [:div.filter-list]
                (map-indexed #(c/service-filter
                               {:idx %1
                                :data %2}) filters))]]])

     (let [trs (i18n/tr-scope [:business-signup :review :location])
           {:business/keys [name email coords geo-location misc]} business
           {:keys [filters whatsapp]} misc]
       [:section
        [:a.header
         {:href (routes/path-for :settings-business-step {:step :location})}
         [:h2 (trs :title "Location")]]
        [:div.grid.summary
         [:span.title (trs :location "Location")] [:span.val (or geo-location (tr :not-set))]
         [:span.title (trs :map "Map")] [c/map-image coords]]])]))

(def ^:private edit-steps
  {:start    {:renderer review
              :finish   :update}
   :info     {:renderer business-information
              :validate [[:business :business/name]
                         [:business :business/email]]
              :next     :services}
   :media    {:renderer photos
              :next     :services}
   :services {:renderer services
              :next     :location
              :validate [[:business :business/misc :filters]]}
   :location {:renderer location
              :next     :whatsapp
              :validate [[:business :business/coords]]}
   :whatsapp {:renderer whatsapp
              :next     :review
              :validate [[:business :business/misc :whatsapp]
                         [:business :business/misc :whatsapp-verified]]}})

(defn form [business]
  (let [form-key :edit-business
        {id :db/id} business
        init-data {:business (-> business
                                 (update :business/misc
                                         (fn [m]
                                           (update m :filters #(or % [])))))}

        {:keys [step]} @(subscribe [:route/parameters])

        ;; init-path (cond-> [:start]
        ;;             step (conj (keyword step)))

        ;; init-path [:start]
        steps edit-steps

        validation validation/edit-business

        on-submit (fn [{:keys [new-data all-data]}]
                    (let [new-media (vec (remove nil? (get-in new-data [:business :business/media])))
                          new-data (-> new-data
                                       (cond-> (seq new-media)
                                         (assoc-in [:business :business/media] new-media)))

                          ;; new-misc (get-in all-data [:business :business/misc])

                          data (-> new-data
                                   (assoc-in [:business :db/id] id)
                                   ;; (assoc-if-val [:business :business/misc] new-misc)
                                   )

                          req {:type          :PUT
                               :url           "/api/businesses"
                               :params        {:data data}
                               :id            :new-request
                               :handler
                               (fn [{:keys [success ex-message] :as res}]
                                 (if success
                                   (do
                                     (rf/dispatch [:toast {:type    "success"
                                                           :message "Business updated. Reloading..."}])
                                     (js/setTimeout (fn []
                                                      (js/window.location.reload)) 800))
                                   (rf/dispatch
                                    [:toast {:type    "error"
                                             :message (format "Failed to save: %s " ex-message)}])))
                               :error-handler (fn [res])}]

                      (rf/dispatch [:do-ajax req])))

        form-args {:schema       validation
                   :change-watch #(storage/write form-key %)
                   :on-submit
                   {:valid   on-submit
                    :invalid (fn [error]
                               (let [error-titles ((:error-titles-fn error) :new-request)]
                                 (rf/dispatch [:toast {:type    "error"
                                                       :timeout 5000
                                                       :title   (tr :page.new-request.submit.invalid/title)
                                                       :message (str/join ", " error-titles)}])))}
                   :init-data    init-data}
        {:keys [*new-data *data form-params] :as form} (form/make-form form-args)
        ;; *-path (r/atom [])
        *path (ra/reaction
                (let [?step (:step @(subscribe [:route/parameters]))]
                  (if ?step
                    [:start (keyword ?step)] [:start])))
        prev-fn #(let [route-name      :settings-business
                       last-route-name @(rf/subscribe [:route/last-route-name])]
                   (if (= route-name last-route-name)
                     (.back js/window.history)
                     (rf/dispatch [:common/navigate! route-name])))
        *save-disabled (ra/reaction
                         (nil? (seq @*new-data)))]
    (fn []
      [:div#business-edit.update
       [:form.default
        form-params
        [sf/step-form {:steps       steps
                       :title       "Business Profile"
                       :*path       *path
                       :no-progress true
                       :form        form
                       :prev-fn     prev-fn
                       :steps-limit 2
                       :*save-disabled *save-disabled

                       ;; :init-path   init-path
                       }]]])))

(defn root []
  (let [id @(subscribe [:current-owner-id])
        business @(subscribe [:current-owner])
        is-business? @(subscribe [:is-business?])
        business (data-utils/wrap-results business)]
    (when is-business?
      [form business]
      #_[page business])))
